import type { ModalOverlayProps } from "react-aria-components"

import {
  Dialog,
  DialogTrigger,
  Modal,
  ModalOverlay as KitModalOverlay,
} from "@/components/ui-kit/untitled/application/modals/modal"

import { cx } from "@uui/utils/cx"

/**
 * The scrim is a print.950 vignette, 55% behind the sheet to 80% at the edges,
 * and never a blur (MDS D5). The kit's overlay carries `bg-overlay/70` and a
 * 6px blur; twMerge drops both for the `scrim` utility.
 */
const ModalOverlay = (props: ModalOverlayProps) => (
  <KitModalOverlay
    {...props}
    className={(state) =>
      cx(
        "scrim bg-transparent backdrop-blur-none",
        typeof props.className === "function"
          ? props.className(state)
          : props.className,
      )
    }
  />
)

export { Dialog, DialogTrigger, Modal, ModalOverlay }
